import { createRouter, createWebHistory } from 'vue-router';
import { readFiltersFromURL } from '../lib/filters';

const ComparisonOverview = () => import('../views/ComparisonOverview.vue');
const ProductClickOut = () => import('../views/ProductClickOut.vue');

// Routes for this comparer:
const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/internet/vergelijken',
            component: ComparisonOverview,
            name: 'compare',
            props: (route) => ({
                urlPostcode: route.query.postcode,
                urlNumber: route.query.nr,
                urlNumberExtension: route.query.extension,
                urlFilters: readFiltersFromURL(route.query),
            }),
        },
        {
            path: '/internet/vergelijken/:provider/:productID',
            component: ProductClickOut,
            name: 'productLink',
            props: (route) => ({
                productID: route.params.productID,
                urlPostcode: route.query.postcode,
                urlNumber: route.query.nr,
                urlFilters: readFiltersFromURL(route.query),
            }),
        },
    ],
});

router.afterEach((to, from) => {
    if (from.name !== null) {
        // We _assume_ that each view has a name
        // Name is null on initial load, so no pageview event triggered
        // if (typeof window.bananas !== 'undefined') {
        //     window.bananas('pageview');
        // }
    }
});
export default router;
